import { Box, Button, Link, Typography, useTheme } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import Div100vh from 'react-div-100vh';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { API_POST, DBRequest, useConfig } from '../../api/api';
import { ColorModeContext } from '../../global/theme/theme';
import FailureCross from '../../components/special/FailureCross';
import SuccessCheck from '../../components/special/SuccessCheck';
import WarningIcon from '@mui/icons-material/Warning';

export const SalesObjectSellerConfirmation = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const config = useConfig();
  const colorMode = useContext(ColorModeContext);

  const { key, status } = useParams();

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    DBRequest({
      config,
      path: `sales-objects/seller-approval/${key}/${status}`,
      method: API_POST(),
      onLoading: setIsLoading,

      onError: (res) => setError(res),
    });
  }, [config]);

  useEffect(() => {
    if (theme.palette.mode === 'dark') colorMode.toggleColorMode();
  }, []);

  const { logoDark, url, email } = config?.owncompanydata || {};

  return (
    <Div100vh>
      <img
        src={'/assets/uploads/exopaper-meeting.webp'}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          position: 'absolute',
          top: '0',
          left: '0',
          objectPosition: '32%',
          zIndex: '-5',
        }}
      />
      <img
        src={logoDark?.temporaryUrl}
        className="absolute top-5 right-5 h-[80px]"
      />
      <Box className="w-full h-full flex items-center justify-center">
        <Box
          className="rounded-lg px-5 pb-5 pt-3 backdrop-blur-md flex flex-col overflow-y-auto max-w-[400px] w-full"
          sx={{
            border: `1px solid rgba(255, 255, 255, 0.2)`,
            background: `linear-gradient(135deg,  rgba(255,255,255, 0.9),rgba(255,255,255, 0.6))`,
            minWidth: '300px',
            maxHeight: '85vh',
          }}
        >
          <Typography fontSize="16px" fontWeight="600" className="opacity-60">
            {t('Digital prospective buyer approval')}
          </Typography>
          {isLoading ? (
            <Box
              className="flex flex-col justify-center items-center h-full"
              sx={{
                height: '300px',
              }}
            >
              <span className="loader"></span>
              <Typography>{t('Loading...')}</Typography>
            </Box>
          ) : (
            <>
              <Box className="flex items-center gap-2 pt-8 pb-8">
                {error ? (
                  <>
                    <WarningIcon color="warning" sx={{ fontSize: '40px' }} />
                    <Typography fontSize="18px" fontWeight={500}>
                      {t(error?.message)}
                    </Typography>
                  </>
                ) : (
                  <>
                    {status === 'approve' ? (
                      <SuccessCheck width="50" height="50" />
                    ) : (
                      <FailureCross width="50" height="50" />
                    )}
                    <Typography fontSize="16px" fontWeight={500}>
                      {t(
                        status === 'approve'
                          ? 'Prospective buyer approved'
                          : 'Prospective buyer denied'
                      )}
                    </Typography>
                  </>
                )}
              </Box>
              <Typography className="pb-4">
                {error
                  ? `${t(
                      'Unfortunately, there were problems during processing. Have you already given your approval? If you have any questions, please feel free to contact us.'
                    )} ${email}`
                  : t(
                      'Thank you for your feedback regarding the prospective buyer. We will process your response as quickly as possible.'
                    )}
              </Typography>
              <a href={url} target="_blank" rel="noopener noreferrer">
                <Button
                  sx={{
                    bgcolor: 'rgb(40,40,40)',
                    color: 'white',
                    transition: 'all 0.3s ease',
                    ':hover': {
                      transform: 'scale(1.02)',
                      bgcolor: 'rgb(40,40,40)',
                    },
                  }}
                >
                  {t('To Website')}
                </Button>
              </a>
            </>
          )}
        </Box>
      </Box>
    </Div100vh>
  );
};
